
<!-- <div class="w-100 h-100 d-flex justify-content-center align-items-center" *ngIf='!(mealPlan && planTimeFrame)'>
    <div class="spinner-grow text-success" role="status" *ngIf='!(mealPlan && planTimeFrame)'>
        <span class="sr-only">Loading...</span>
    </div>    
</div> -->

<!-- <section  class="requests-finished mt-5 pt-5 d-flex justify-content-center align-items-center">
  <figure>
    <img class="img-fluid" src="../../../assets/4o4.png" >
  </figure>
</section> -->

<section class="user-input my-5 pt-5 d-flex justify-content-center align-items-center" >
  <div class="container ">

    <form class="py-5 rounded bg-lightgreen">

        <div class="row">

          <div class="form-group col-md-12 d-flex justify-content-center">
            <input class="form-control w-50" id="target-calories" type="search" placeholder="Enter you Target calories per day (maximum per day 3000)">
          </div>

          <div class="form-group col-md-12 d-flex justify-content-center">
            <p class="alert alert-danger py-2 px-5 w-50 text-center" *ngIf='emptyErrorMsg'>This filed can not be empty</p>
          </div>

          <div class="form-group col-md-12 d-flex justify-content-center">
            <p class="alert alert-danger py-2 px-5 w-50 text-center" *ngIf='nanErrorMsg'>Input should be a number</p>
          </div>

          <div class="form-group col-md-12 d-flex justify-content-center">
            <p class="alert alert-danger py-2 px-5 w-50 text-center" *ngIf='rangeErrorMsg'>maximum number is 3000</p>
          </div>

          <div class="col-md-12 d-flex justify-content-center " >

            <div class="d-inline mr-4">
              <div class="d-flex align-items-center">
                <input type="radio" id="day" name="time" value="day" checked>
                <label class="pl-2 mb-0" for="day">day</label><br>
              </div>
            </div>

            <div class="d-inline ml-4 ">
              <div class="d-flex align-items-center">
                <input type="radio" id="week" name="time" value="week">
                <label class="pl-2 mb-0" for="week">week</label><br>
              </div>
              
            </div>
            
          </div>

          <div class="col-md-12 d-flex justify-content-center my-3">
            <button class="btn btn-green px-5" id="target-calories" type="button" (click)='search()'>Search</button>
          </div>
  

        </div>
        

    </form>
  </div>
</section>

<section #planResults class="plan-results" *ngIf='mealPlan'>
    <div class="container">
        <div class="row">


            <!-- if plan = day -->
            <div class="week-plan col-md-12 text-center mt-5 " *ngIf='planTimeFrame=="day" '>

                <div class="row row-cols-1 row-cols-md-3 mx-3">

                    <h2 class="col-md-12  rounded bg-green mb-5">Your day plan</h2>

                    <div class="col-md-4 mb-5" *ngFor='let meal of mealPlan.meals'>

                        <a class="recipe-link" [routerLink]="['/recipeInfo', meal.id]">
                            <div class="card h-100 recipe-card">
                                <figure class="img-wrapper position-relative" >
                                    <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                                        <h2 class="text-white">View Details</h2>
                                    </div>
                                    <img [src]="prefixImgSrc+meal.id+imgSize" [alt]='meal.title' class="card-img-top" >
                                </figure>
                                <div class="card-body p-1 pt-2 ">
                                  <h2 class="card-title ">{{meal.title}}</h2>
                                </div>
                              </div>
                          </a>

                    </div>

                    <div class="nutrients col-md-12 " >

                        <h2 class="col-md-12 bg-lightgreen rounded">nutrients</h2>

                        <table class="table col-md-12 mt-3 mb-5 table-border ">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                                <th scope="row">1</th>
                                <td>protein</td>
                                <td>{{mealPlan.nutrients.protein}}</td>
                              </tr>

                              <tr >
                                <th scope="row">2</th>
                                <td>fat</td>
                                <td>{{mealPlan.nutrients.fat}}</td>
                              </tr>

                              <tr >
                                <th scope="row">3</th>
                                <td>carbohydrates</td>
                                <td>{{mealPlan.nutrients.carbohydrates}}</td>
                              </tr>

                              <tr >
                                <th scope="row">4</th>
                                <td>Total calories</td>
                                <td>{{mealPlan.nutrients.calories}}</td>
                              </tr>

                            </tbody>
                          </table>


                    </div>

                </div>

            </div>

            <!-- if plan = week -->
            <div class="week-plan col-md-12 text-center mt-5 " *ngIf='planTimeFrame=="week" '>

                <div class="row row-cols-1 row-cols-md-3">

                    <!-- friday -->
                    <h2 class="col-md-12 rounded bg-green mb-5">Friday</h2>

                    <div class="col-md-4 mb-5" *ngFor='let meal of mealPlan.friday.meals'>

                        <a class="recipe-link" [routerLink]="['/recipeInfo', meal.id]">
                            <div class="card h-100 recipe-card">
                                <figure class="img-wrapper position-relative" >
                                    <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                                        <h2 class="text-white">View Details</h2>
                                    </div>
                                    <img [src]="prefixImgSrc+meal.id+imgSize" [alt]='meal.title' class="card-img-top" >
                                </figure>
                                <div class="card-body p-1 pt-2 ">
                                  <h2 class="card-title ">{{meal.title}}</h2>
                                </div>
                            </div>
                        </a>

                    </div>

                    <div class="nutrients col-md-12 " >

                        <h2 class="col-md-12  rounded bg-lightgreen">nutrients</h2>

                        <table class="table col-md-12 mt-3 mb-5 table-border">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                                <th scope="row">1</th>
                                <td>protein</td>
                                <td>{{mealPlan.friday.nutrients.protein}}</td>
                              </tr>

                              <tr >
                                <th scope="row">2</th>
                                <td>fat</td>
                                <td>{{mealPlan.friday.nutrients.fat}}</td>
                              </tr>

                              <tr >
                                <th scope="row">3</th>
                                <td>carbohydrates</td>
                                <td>{{mealPlan.friday.nutrients.carbohydrates}}</td>
                              </tr>

                              <tr >
                                <th scope="row">4</th>
                                <td>Total calories</td>
                                <td>{{mealPlan.friday.nutrients.calories}}</td>
                              </tr>

                            </tbody>
                        </table>


                    </div>

                    <!-- friday -->

                    <!-- saturday -->
                    <h2 class="col-md-12  rounded bg-green mb-5">Saturday</h2>

                    <div class="col-md-4 mb-5" *ngFor='let meal of mealPlan.saturday.meals'>

                        <a class="recipe-link" [routerLink]="['/recipeInfo', meal.id]">
                            <div class="card h-100 recipe-card">
                                <figure class="img-wrapper position-relative" >
                                    <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                                        <h2 class="text-white">View Details</h2>
                                    </div>
                                    <img [src]="prefixImgSrc+meal.id+imgSize" [alt]='meal.title' class="card-img-top" >
                                </figure>
                                <div class="card-body p-1 pt-2 ">
                                  <h2 class="card-title ">{{meal.title}}</h2>
                                </div>
                            </div>
                        </a>

                    </div>

                    <div class="nutrients col-md-12 " >

                        <h2 class="col-md-12  rounded bg-lightgreen">nutrients</h2>

                        <table class="table col-md-12 mt-3 mb-5 table-border">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                                <th scope="row">1</th>
                                <td>protein</td>
                                <td>{{mealPlan.saturday.nutrients.protein}}</td>
                              </tr>

                              <tr >
                                <th scope="row">2</th>
                                <td>fat</td>
                                <td>{{mealPlan.saturday.nutrients.fat}}</td>
                              </tr>

                              <tr >
                                <th scope="row">3</th>
                                <td>carbohydrates</td>
                                <td>{{mealPlan.saturday.nutrients.carbohydrates}}</td>
                              </tr>

                              <tr >
                                <th scope="row">4</th>
                                <td>Total calories</td>
                                <td>{{mealPlan.saturday.nutrients.calories}}</td>
                              </tr>

                            </tbody>
                        </table>


                    </div>

                    <!-- saturday -->

                    <!-- sunday -->
                    <h2 class="col-md-12  rounded bg-green mb-5">Sunday</h2>

                    <div class="col-md-4 mb-5" *ngFor='let meal of mealPlan.sunday.meals'>

                        <a class="recipe-link" [routerLink]="['/recipeInfo', meal.id]">
                            <div class="card h-100 recipe-card">
                                <figure class="img-wrapper position-relative" >
                                    <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                                        <h2 class="text-white">View Details</h2>
                                    </div>
                                    <img [src]="prefixImgSrc+meal.id+imgSize" [alt]='meal.title' class="card-img-top" >
                                </figure>
                                <div class="card-body p-1 pt-2 ">
                                  <h2 class="card-title ">{{meal.title}}</h2>
                                </div>
                            </div>
                        </a>

                    </div>

                    <div class="nutrients col-md-12 " >

                        <h2 class="col-md-12  rounded bg-lightgreen">nutrients</h2>

                        <table class="table col-md-12 mt-3 mb-5 table-border">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                                <th scope="row">1</th>
                                <td>protein</td>
                                <td>{{mealPlan.sunday.nutrients.protein}}</td>
                              </tr>

                              <tr >
                                <th scope="row">2</th>
                                <td>fat</td>
                                <td>{{mealPlan.sunday.nutrients.fat}}</td>
                              </tr>

                              <tr >
                                <th scope="row">3</th>
                                <td>carbohydrates</td>
                                <td>{{mealPlan.sunday.nutrients.carbohydrates}}</td>
                              </tr>

                              <tr >
                                <th scope="row">4</th>
                                <td>Total calories</td>
                                <td>{{mealPlan.sunday.nutrients.calories}}</td>
                              </tr>

                            </tbody>
                        </table>


                    </div>

                    <!-- sunday -->

                    <!-- monday -->
                    <h2 class="col-md-12  rounded bg-green mb-5">Monday</h2>

                    <div class="col-md-4 mb-5" *ngFor='let meal of mealPlan.monday.meals'>

                        <a class="recipe-link" [routerLink]="['/recipeInfo', meal.id]">
                            <div class="card h-100 recipe-card">
                                <figure class="img-wrapper position-relative" >
                                    <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                                        <h2 class="text-white">View Details</h2>
                                    </div>
                                    <img [src]="prefixImgSrc+meal.id+imgSize" [alt]='meal.title' class="card-img-top" >
                                </figure>
                                <div class="card-body p-1 pt-2 ">
                                  <h2 class="card-title ">{{meal.title}}</h2>
                                </div>
                            </div>
                        </a>

                    </div>

                    <div class="nutrients col-md-12 " >

                        <h2 class="col-md-12  rounded bg-lightgreen">nutrients</h2>

                        <table class="table col-md-12 mt-3 mb-5 table-border">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                                <th scope="row">1</th>
                                <td>protein</td>
                                <td>{{mealPlan.monday.nutrients.protein}}</td>
                              </tr>

                              <tr >
                                <th scope="row">2</th>
                                <td>fat</td>
                                <td>{{mealPlan.monday.nutrients.fat}}</td>
                              </tr>

                              <tr >
                                <th scope="row">3</th>
                                <td>carbohydrates</td>
                                <td>{{mealPlan.monday.nutrients.carbohydrates}}</td>
                              </tr>

                              <tr >
                                <th scope="row">4</th>
                                <td>Total calories</td>
                                <td>{{mealPlan.monday.nutrients.calories}}</td>
                              </tr>

                            </tbody>
                        </table>


                    </div>

                    <!-- monday -->

                    <!-- tuesday -->
                    <h2 class="col-md-12  rounded bg-green mb-5">Tuesday</h2>

                    <div class="col-md-4 mb-5" *ngFor='let meal of mealPlan.tuesday.meals'>

                        <a class="recipe-link" [routerLink]="['/recipeInfo', meal.id]">
                            <div class="card h-100 recipe-card">
                                <figure class="img-wrapper position-relative" >
                                    <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                                        <h2 class="text-white">View Details</h2>
                                    </div>
                                    <img [src]="prefixImgSrc+meal.id+imgSize" [alt]='meal.title' class="card-img-top" >
                                </figure>
                                <div class="card-body p-1 pt-2 ">
                                  <h2 class="card-title ">{{meal.title}}</h2>
                                </div>
                            </div>
                        </a>

                    </div>

                    <div class="nutrients col-md-12 " >

                        <h2 class="col-md-12  rounded bg-lightgreen">nutrients</h2>

                        <table class="table col-md-12 mt-3 mb-5 table-border">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                                <th scope="row">1</th>
                                <td>protein</td>
                                <td>{{mealPlan.tuesday.nutrients.protein}}</td>
                              </tr>

                              <tr >
                                <th scope="row">2</th>
                                <td>fat</td>
                                <td>{{mealPlan.tuesday.nutrients.fat}}</td>
                              </tr>

                              <tr >
                                <th scope="row">3</th>
                                <td>carbohydrates</td>
                                <td>{{mealPlan.tuesday.nutrients.carbohydrates}}</td>
                              </tr>

                              <tr >
                                <th scope="row">4</th>
                                <td>Total calories</td>
                                <td>{{mealPlan.tuesday.nutrients.calories}}</td>
                              </tr>

                            </tbody>
                        </table>


                    </div>

                    <!-- tuesday -->

                    <!-- wednesday -->
                    <h2 class="col-md-12  rounded bg-green mb-5">Wednesday</h2>

                    <div class="col-md-4 mb-5" *ngFor='let meal of mealPlan.wednesday.meals'>

                        <a class="recipe-link" [routerLink]="['/recipeInfo', meal.id]">
                            <div class="card h-100 recipe-card">
                                <figure class="img-wrapper position-relative" >
                                    <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                                        <h2 class="text-white">View Details</h2>
                                    </div>
                                    <img [src]="prefixImgSrc+meal.id+imgSize" [alt]='meal.title' class="card-img-top" >
                                </figure>
                                <div class="card-body p-1 pt-2 ">
                                  <h2 class="card-title ">{{meal.title}}</h2>
                                </div>
                            </div>
                        </a>

                    </div>

                    <div class="nutrients col-md-12 " >

                        <h2 class="col-md-12  rounded bg-lightgreen">nutrients</h2>

                        <table class="table col-md-12 mt-3 mb-5 table-border">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                                <th scope="row">1</th>
                                <td>protein</td>
                                <td>{{mealPlan.wednesday.nutrients.protein}}</td>
                              </tr>

                              <tr >
                                <th scope="row">2</th>
                                <td>fat</td>
                                <td>{{mealPlan.wednesday.nutrients.fat}}</td>
                              </tr>

                              <tr >
                                <th scope="row">3</th>
                                <td>carbohydrates</td>
                                <td>{{mealPlan.wednesday.nutrients.carbohydrates}}</td>
                              </tr>

                              <tr >
                                <th scope="row">4</th>
                                <td>Total calories</td>
                                <td>{{mealPlan.wednesday.nutrients.calories}}</td>
                              </tr>

                            </tbody>
                        </table>


                    </div>

                    <!-- wednesday -->

                    <!-- thursday -->
                    <h2 class="col-md-12  rounded bg-green mb-5">Thursday</h2>

                    <div class="col-md-4 mb-5" *ngFor='let meal of mealPlan.thursday.meals'>

                        <a class="recipe-link" [routerLink]="['/recipeInfo', meal.id]">
                            <div class="card h-100 recipe-card">
                                <figure class="img-wrapper position-relative" >
                                    <div class="img-overlay d-flex align-items-center justify-content-center rounded">
                                        <h2 class="text-white">View Details</h2>
                                    </div>
                                    <img [src]="prefixImgSrc+meal.id+imgSize" [alt]='meal.title' class="card-img-top" >
                                </figure>
                                <div class="card-body p-1 pt-2 ">
                                  <h2 class="card-title ">{{meal.title}}</h2>
                                </div>
                            </div>
                        </a>

                    </div>

                    <div class="nutrients col-md-12 " >

                        <h2 class="col-md-12  rounded bg-lightgreen">nutrients</h2>

                        <table class="table col-md-12 mt-3 mb-5 table-border">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">name</th>
                                <th scope="col">amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                                <th scope="row">1</th>
                                <td>protein</td>
                                <td>{{mealPlan.thursday.nutrients.protein}}</td>
                              </tr>

                              <tr >
                                <th scope="row">2</th>
                                <td>fat</td>
                                <td>{{mealPlan.thursday.nutrients.fat}}</td>
                              </tr>

                              <tr >
                                <th scope="row">3</th>
                                <td>carbohydrates</td>
                                <td>{{mealPlan.thursday.nutrients.carbohydrates}}</td>
                              </tr>

                              <tr >
                                <th scope="row">4</th>
                                <td>Total calories</td>
                                <td>{{mealPlan.thursday.nutrients.calories}}</td>
                              </tr>

                            </tbody>
                        </table>


                    </div>

                    <!-- thursday -->

                </div>
            </div>
        </div>
    </div>
</section>
